import { AddressService, AddressServiceModule } from '@b2b/common/services/address';
import { Address, TODO } from '@b2b/types/core';
import angular, { ITimeoutService } from 'angular';

VCardEditCustomerDirective.$inject = ['$timeout', 'ValidateService', 'AddressService'];

function VCardEditCustomerDirective($timeout: ITimeoutService, ValidateService: TODO, AddressService: AddressService) {
  VCardEditCustomerController.$inject = ['$scope'];

  function VCardEditCustomerController($scope: TODO) {
    const ctrl = {
      selectedAddress: {} as TODO,
      address: {},
      addressType: 'existing',

      addresses: [],

      addressHeaderTitle: 'Member Information',

      addressTitles: [],

      errors: [],
      selectedTitle: false as TODO | false,
      titles: [
        {
          title: 'ms',
          name: 'Ms',
        },
        {
          title: 'miss',
          name: 'Miss',
        },
        {
          title: 'mrs',
          name: 'Mrs',
        },
        {
          title: 'mr',
          name: 'Mr',
        },
        {
          title: 'rev',
          name: 'Rev',
        },
        {
          title: 'dr',
          name: 'Dr',
        },
        {
          title: 'prof',
          name: 'Prof',
        },
      ],

      cardTypes: [
        {
          cardType: 'primary',
          name: 'Primary',
        },
        {
          cardType: 'secondary',
          name: 'Secondary',
        },
      ],

      newAddress: {
        name: '+ New Address',
      },

      noAddress: {
        name: 'None',
      },

      trackNameOnCard: false,
      submitted: false,

      init: function () {
        if (!$scope.model.name) {
          this.trackNameOnCard = true;
        }

        this.selectTitle();

        this.selectAddress();

        this.addresses = this.getAddresses();

        this.addressTitles = this.addresses.map(function (address) {
          return { address: address.name, name: address.name };
        });

        this.checkAddress();

        if ($scope.addressHeaderTitle) {
          $scope.vcardEditCustomer.addressHeaderTitle = $scope.addressHeaderTitle;
        }

        $scope.$on('VcardCardholder::Process', this.onProcess);
        $scope.$on('AddressCreate::Complete', this.onAddressCreateComplete);
        $scope.$on('AddressCreate::Error', this.onAddressCreateError);
      },

      selectAddress: function () {
        if ($scope.model.address) {
          $scope.model.address = AddressService.getFormattedAddress($scope.model.address);
        }

        this.selectedAddress = $scope.model.address || null;
      },

      selectTitle: function () {
        if ($scope.model.prefix) {
          this.selectedTitle = this.findSalutation($scope.model.prefix);
        }
      },

      getAddresses: function () {
        let addresses: TODO[] = [];
        let found: Address | null = null;

        if ($scope.addresses instanceof Array) {
          addresses = [].concat($scope.addresses);
        }

        if (this.selectedAddress) {
          found = AddressService.isDuplicateAddress(this.selectedAddress, addresses);
          if (found) {
            this.selectedAddress = found;
          }
        }

        addresses.unshift({
          name: this.newAddress.name,
        });

        addresses.unshift({
          name: this.noAddress.name,
        });

        if (!this.selectedAddress || !found) {
          this.selectedAddress = addresses[0];
          this.addressType = 'none';
        }

        return addresses;
      },

      isCardType: function (type) {
        return $scope.model && $scope.model.cardType && $scope.model.cardType === type;
      },

      marshalCardholder: function () {
        this.updateCardholderAddress();
        this.updateCardType();
        $scope.model.customerSource = $scope.model.customerSource || 'acme';
      },

      updateCardholderAddress: function () {
        var key;

        $scope.model.address = AddressService.getUnFormattedAddress(this.address);

        if ($scope.model.address) {
          for (key in $scope.model.address) {
            if ($scope.model.address.hasOwnProperty(key)) {
              $scope.model[key] = $scope.model.address[key];
            }
          }
        }
      },

      updateCardType: function () {
        $scope.model.cardType = this.isPrimaryCardholder() ? this.cardTypes[0].cardType : this.cardTypes[1].cardType;
      },

      generateNameOnCard: function () {
        const name: string[] = [];

        if ($scope.model.prefix) {
          const prefix = this.findSalutation($scope.model.prefix);
          if (prefix) {
            name.push(prefix);
          }
        }

        if ($scope.model.firstName) {
          name.push($scope.model.firstName);
        }

        if ($scope.model.middleName) {
          name.push($scope.model.middleName);
        }

        if ($scope.model.lastName) {
          name.push($scope.model.lastName);
        }

        return name.join(' ');
      },

      findSalutation: function (prefix) {
        var found = this.titles.filter(function (title) {
          return title.title === prefix;
        });

        return found.length ? found[0].name : '';
      },

      copyNameOnCard: function (force = false) {
        //next tick
        $timeout(() => {
          if (force || ctrl.trackNameOnCard) {
            $scope.model.name = ctrl.generateNameOnCard();
          }
        }, 0);
      },

      nameOnCardChanged: function () {
        //next tick
        $timeout(() => {
          if (ctrl.nameOnCardDiffers()) {
            ctrl.trackNameOnCard = false;
          } else {
            ctrl.trackNameOnCard = true;
          }
        }, 0);
      },

      nameOnCardDiffers: function () {
        var nameOnCard = this.generateNameOnCard();
        return $scope.model.name && nameOnCard !== $scope.model.name;
      },

      addressUpdated: function (props: { added: boolean; editExisting?: boolean; noAddress?: boolean }) {
        if (props.added || props.editExisting) {
          if (props.editExisting && this.selectedAddress) {
            this.address = AddressService.getFormattedAddress(angular.copy(this.selectedAddress));
          } else {
            this.address = {};
          }
          this.addressType = 'new';
        } else if (props.noAddress) {
          this.addressType = 'none';
          this.address = {};
        } else {
          this.addressType = 'existing';
        }
      },

      checkAddress: function () {
        if (!ValidateService.validate(this.getValidators(true))) {
          this.errors = ValidateService.getErrorHash();
        }
      },

      getValidators: function (addressOnly = false) {
        var validators,
          contactValidators = {
            nameOnCard: addressOnly
              ? []
              : [
                  {
                    field: 'vcard-edit-customer-name-on-card',
                    len: { message: 'Invalid name on card', test: { value: $scope.model.name } },
                  },
                ],
            name: addressOnly
              ? []
              : [
                  {
                    field: 'vcard-edit-customer-first-name',
                    len: { message: 'Invalid name', test: { value: $scope.model.firstName } },
                  },
                  {
                    field: 'vcard-edit-customer-last-name',
                    len: { message: 'Invalid name', test: { value: $scope.model.lastName } },
                  },
                ],
            contact: addressOnly
              ? []
              : [
                  {
                    field: 'vcard-edit-customer-email',
                    email: {
                      message: 'Invalid email',
                      test: function () {
                        return $scope.model.email;
                      },
                    },
                  },
                  {
                    field: 'vcard-edit-customer-phone',
                    phone: {
                      message: 'Invalid phone number',
                      test: function () {
                        return $scope.model.phoneNumber;
                      },
                    },
                  },
                ],
            address: [
              {
                field: 'vcard-edit-customer-address',
                len: {
                  message: ctrl.invalidAddressError(),
                  test: { value: ctrl.validateAddress() ? '1' : '' },
                },
              },
              {
                field: 'vcard-edit-customer-new-address',
                len: {
                  message: ctrl.invalidAddressError(),
                  test: { value: ctrl.validateAddress() ? '1' : '' },
                },
              },
            ],
          };

        if (this.isPrimaryCardholder()) {
          validators = contactValidators.name;
          if (this.useValidation()) {
            validators = validators.concat(contactValidators.address);
          }
        } else {
          validators = contactValidators.nameOnCard;
        }

        return validators;
      },

      checkRequired: function (field) {
        var r = false;

        switch (field) {
          case 'vcard-edit-customer-address':
          case 'vcard-edit-customer-new-address':
          case 'vcard-edit-customer-last-name':
          case 'vcard-edit-customer-first-name':
            r = this.isPrimaryCardholder();
            break;
          case 'vcard-edit-customer-name-on-card':
            r = this.isCardType('secondary');
            break;
        }

        return r;
      },

      validateAddressSelector: function () {
        return ctrl.submitted === undefined || (ctrl.submitted === true && angular.equals(this.address, {}) === false);
      },

      validateAddress: function () {
        var address = this.addressType === 'existing' ? this.selectedAddress : this.address,
          r = true,
          keys = AddressService.validateFields.slice();
        if (this.useValidation() && address) {
          angular.forEach(keys, function (key) {
            if (r && address.hasOwnProperty(key) && address[key]) {
              r = address[key].length;
            } else {
              r = false;
            }
          });
        }

        return r;
      },

      invalidAddressError: function () {
        var r = 'Invalid address';

        if (this.isPrimaryCardholder() && this.addressType === 'none') {
          r = ctrl.submitted ? 'Required for primary customer' : ' '; //this is a space intentionally - hack
        }

        return r;
      },

      isPrimaryCardholder: function () {
        return !!this.makePrimary || this.isCardType('primary');
      },

      useValidation: function () {
        return $scope.validate !== undefined && $scope.validate === 'true' && ctrl.isPrimaryCardholder();
      },

      setAddress: function () {
        var addressEmpty = !this.selectedAddress;

        if (this.isAddressType('none')) {
          this.address = AddressService.getUnFormattedAddress(null, true);
        } else {
          this.selectedAddress = AddressService.getUnFormattedAddress(this.selectedAddress, true);

          if (addressEmpty) {
            //ENG-4096
            this.selectedAddress.name = '';
          }

          if (this.isAddressType('existing')) {
            this.address = this.selectedAddress;
          }
        }
      },

      isAddressType: function (type) {
        return this.addressType === type;
      },

      done: function () {
        if (ValidateService.validate(ctrl.getValidators())) {
          ctrl.setAddress();

          ctrl.marshalCardholder();
          $scope.$emit('VcardCardholder::Complete');
        } else {
          ctrl.errors = ValidateService.getErrorHash();
        }
      },

      onProcess: function (e, data) {
        ctrl.submitted = true;

        if (ctrl.address) {
          switch (ctrl.addressType) {
            case 'new':
              $scope.$broadcast('AddressCreate::Process');
              break;
            case 'none':
            //falls through
            case 'existing':
              ctrl.done();
              break;
          }
        } else {
          ctrl.done();
        }
      },

      onAddressCreateComplete: function (e, data: { address: Address; select: TODO | undefined }) {
        ctrl.address = data.address;
        ctrl.done();
      },

      onAddressCreateError: function (e, data) {},

      onTitleChange: function (e, data) {
        $scope.model.prefix = ctrl.selectedTitle.title;
        ctrl.copyNameOnCard();
      },

      onAddressSelected: function (e, data) {
        ctrl.errors = [];

        if (ctrl.selectedAddress.name === ctrl.newAddress.name) {
          ctrl.addressUpdated({ added: true });
        } else if (ctrl.selectedAddress.name === ctrl.noAddress.name) {
          ctrl.addressUpdated({ added: false, editExisting: false, noAddress: true });
        } else {
          ctrl.addressUpdated({ added: false });
        }
      },
    };

    $scope.vcardEditCustomer = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/vcard/edit/customer/customer.tpl.html',
    scope: {
      model: '=',
      addressHeaderTitle: '@',
      addresses: '=',
      validate: '@',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: VCardEditCustomerController,
  };
}

export const VCardEditCustomerDirectiveModule = angular
  .module('acme.common.directive.vcardEditCustomer', ['acme.common.service.validate', AddressServiceModule])
  .directive('vcardEditCustomer', VCardEditCustomerDirective).name;
